"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var breakpoints = {
  sm: "479",
  md: "1019",
  lg: "1319"
};

exports.default = breakpoints;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-theme/dist/breakpoints.js
// module id = 234
// module chunks = 168707334958949